// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-classification-analysis-model-inferencing',
//   templateUrl: './classification-analysis-model-inferencing.component.html',
//   styleUrls: ['./classification-analysis-model-inferencing.component.scss'],
// })
// export class ClassificationAnalysisModelInferencingComponent  implements OnInit {

//   constructor() { }

//   ngOnInit() {}

// }

import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { SttInferenceSaveComponent } from '../stt-inference-save/stt-inference-save.component';
import { ClassificationInferenceSaveComponent } from '../classification-inference-save/classification-inference-save.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-classification-analysis-model-inferencing',
  templateUrl: './classification-analysis-model-inferencing.component.html',
  styleUrls: ['./classification-analysis-model-inferencing.component.scss'],
})
export class ClassificationAnalysisModelInferencingComponent  implements OnInit {
  @Input() initiator: string = ''; // The component that initiated the modal
  @Input() data: any = {}; // The component that initiated the modal

  answer: string = "";
  isAnswerValid : boolean = true; // Flag to track if the answer is valid

  staticStats: string[] = [];

  showStaticList: boolean = false;

  // constructor(private modalCtrl: ModalController) { }
  constructor(
      private modalCtrl: ModalController,
      private globalService:GlobalService,
      private apiService: ApiService,
      private fb: FormBuilder,
    ){}

  ngOnInit() {
     console.log('daaaaaaaaa before saving:', this.data);
     console.log('initiator:', this.initiator);
     if (this.data && Array.isArray(this.data.available_answers)) {
       this.staticStats = this.data.available_answers;
     }
  }

  ngOnDestroy() {
    this.answer = ''; // Clear the answer when the component is destroyed
  }

  async openClassificationInferenceSaveFormModal(result: any,response_data: any) {
        const modal = await this.modalCtrl.create({
          component: ClassificationInferenceSaveComponent,
          animated: false,
          backdropDismiss: false,  // Prevent closing when clicking outside
          cssClass: 'large-modal-8', //custom class for styling
          componentProps:{
            'initiator':'fromopenClassificationInferenceSaveFormModal',
            result: result, // Pass the data to the modal
            data: response_data, // Pass the data to the modal
            answer: this.answer // Pass the answer to the modal
    

          }
        });
    
        await modal.present();
    
        const { data } = await modal.onDidDismiss();
        if (data) {
          if(data === 'save'){
              this.closeModal(data);
            }else{
              this.answer = '';
              this.closeModal('close')
            }
          
    
        }else{
        }  
      }

  saveAnswer() {
    this.data.answer = this.answer; // Trim whitespace from answer
    console.log('IIIIIIInvalid:', this.isAnswerValid);
    
    try {
      if(this.data.answer.trim() !== '') {
        this.isAnswerValid = true; // Set to true if answer is not empty
        this.globalService.logoutLoading();
        this.apiService.getClassificationInferenceResult(this.data.guid,this.answer,this.data.language).subscribe(
          async (response) => {
            console.log("Data get successfully:", response);
            const result = response.data;
            this.openClassificationInferenceSaveFormModal(result,this.data);
            // Add logic to emit or handle saved answer
            await this.globalService.dismissLoading();
            
          },
          (err) => {
            this.globalService.dismissLoading();
          }
        );

      }else{
        console.log('EEEEEEEEEEEEEEEEEEE before saving:', this.data);
        this.isAnswerValid = false;
        setTimeout(() => {
          this.isAnswerValid = true;
        }, 1500); // Change after one second (1000 milliseconds)
      }
      
    } catch (error) {
      console.error('Error saving answer:', error);
      // alert('Failed to save answer. Please try again.');
    }

    // sttInferenceResult


    
  }

//   retriveSTTTextList() {
//     try {
//       this.apiService.getSTTTextList(lang,this.currentPage,this.pageSize).subscribe(
//         async (response) => {
//           console.log("Data get successfully:", response);
//           this.textListData = response.data; // Assuming the API returns an array of text records
//           this.totalPages = Math.ceil(response.totalCount / Number(this.pageSize)) || 1;
//           await this.globalService.dismissLoading();
          
//         },
//         (err) => {
//           this.totalPages = 1;
//           this.textListData = [];
//           console.error("Error during API call:", err);
//           alert("Failed to save data. Please try again.");
//           this.globalService.dismissLoading();
//         }
//       );

//     } catch (error) {
//       console.error('Unexpected error while data loading:', error);
//       alert('Failed to load data. Please try again.');
//       this.globalService.dismissLoading();
//     }
// }

  closeModal(target:string) {
      this.modalCtrl.dismiss(target);    
    }

  toggleStaticList() {
    this.showStaticList = !this.showStaticList;
  }
  }



